// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-sMuS","title":"styles_title__C4pIS"};